import Trinity from '@core/scripts/components/trinity-adapter.js';
import {useContext} from 'react';
import {articleOverviewStaticContext} from '../ArticleOverviewStatic.jsx';

export const useTrinity = () => {
    const {pageType, shopId} = useContext(articleOverviewStaticContext);

    const pageTypeUpperCase = pageType.toUpperCase();
    const pageAttribute = pageType === 'srp' ? 'search' : 'aop';

    const sendFilterView = (filterArea, visibleFilter, eventVersion) => {
        Trinity.sendTrinityEvent({
            schema: {
                version: eventVersion,
                name: `VIEW_${pageTypeUpperCase}_FILTER`,
            },
            attributes: {
                filterView: visibleFilter,
                filterArea: filterArea,
                shopId: shopId.current ? shopId.current : 0,
                page: pageAttribute,
            },
        });
    };

    const sendClickBasic = (clickName, eventVersion, clickObject = 'button') => {
        Trinity.sendTrinityEvent({
            schema: {
                version: eventVersion,
                name: `CLICK_${pageTypeUpperCase}_BASIC`,
            },
            attributes: {
                clickName: clickName,
                shopId: shopId.current ? shopId.current : 0,
                page: pageAttribute,
                object: clickObject,
            },
        });
    };

    const sendLoadMoreBlicked = (totalArticles)  => {
        Trinity.sendTrinityEvent({
            schema: {
                version: 1,
                name: `CLICK_LOADMORE_STYLES`,
            },
            attributes: {
                clickName: 'loadMoreStyles',
                shopId: shopId.current ? shopId.current : 0,
                totalAmountStyles: totalArticles,
                page: pageAttribute,
                object: 'button',
            },
        });
    }

    const sendTopDealBenefitSeen = (itemId)  => {
        Trinity.sendTrinityEvent({
            schema: {
                version: 2,
                name: `VIEW_LABEL_TOPDEAL`,
            },
            attributes: {
                itemId,
                page: pageAttribute,
            },
        });
    }
    const sendSearchSurveyView = (searchTerm) => {
        Trinity.sendTrinityEvent({
            schema: {
                version: 1,
                name: 'VIEW_SEARCH_SURVEY',
            },
            attributes: {
                viewName: 'surveyDisplayed',
                searchTerm,
            },
        });
    };

    const sendSearchSurveyClick = (params) => {
        const attributes = {
            clickName: params.clickName,
            starRatingValue: params.starRatingValue,
            object: params.object,
        };
        if (params.searchTerm) attributes.searchTerm = params.searchTerm;
        if (params.checkboxAnswers) attributes.checkboxAnswers = params.checkboxAnswers;
        if (params.freeTextAnswer) attributes.freeTextAnswer = params.freeTextAnswer;

        Trinity.sendTrinityEvent({
            schema: {
                version: 1,
                name: 'CLICK_SEARCH_SURVEY',
            },
            attributes,
        });
    };

    return {sendFilterView, sendClickBasic, sendLoadMoreBlicked, sendTopDealBenefitSeen, sendSearchSurveyView, sendSearchSurveyClick};
};
